import React from 'react';
import { BadgeCheck, Tag, Zap } from 'lucide-react';
export const WhyBucknut = () => {
  const reasons = [{
    icon: BadgeCheck,
    title: 'Every Item Authenticated',
    description: 'We guarantee the authenticity of every signature and grade. Shop with absolute confidence.'
  }, {
    icon: Tag,
    title: 'Collector-First Pricing',
    description: 'Fair market values and transparent pricing. We are collectors serving collectors.'
  }, {
    icon: Zap,
    title: 'Shipped Fast and Insured',
    description: 'Your grails are packed securely, fully insured, and shipped out lightning fast.'
  }];
  return <section className="py-16 md:py-24 bg-white" data-id="element-150">
      <div className="container mx-auto px-4" data-id="element-151">
        <div className="text-center mb-12" data-id="element-152">
          <h2 className="font-heading text-3xl md:text-4xl text-ink uppercase tracking-wide" data-id="element-153">
            Why Bucknut
          </h2>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-8" data-id="element-154">
          {reasons.map((reason, idx) => <div key={idx} className="flex flex-col items-center text-center bg-cream p-8 border-4 border-ink shadow-comic" data-id="element-155">
              <div className="w-20 h-20 bg-scarlet border-4 border-ink shadow-[4px_4px_0px_0px_#1A1A1A] flex items-center justify-center mb-6 text-white rotate-3" data-id="element-156">
                <reason.icon className="w-10 h-10" data-id="element-157" />
              </div>
              <h3 className="font-heading text-2xl text-ink mb-3 uppercase tracking-wider" data-id="element-158">
                {reason.title}
              </h3>
              <p className="text-ink font-bold leading-relaxed max-w-sm" data-id="element-159">
                {reason.description}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
};